import React from 'react'

import MarkdownHelper from '../../utils/MarkdownHelper'
import ReactMarkdown from "react-markdown"

import { FootnotesFromContext } from "../../subcomponents/Footnotes";

import {default as t} from '../../utils/Translate'
import { useSuperscript } from '../../utils/SuperscriptHelper';

const TeaserLogInLogOutFinance = ({campaign, lang, footnotesWarningText}) => {
    const campaignWithSuperscript = {
        ...campaign,
        title_caption: useSuperscript(campaign.title_caption, true),
        title_2_short: useSuperscript(campaign.title_2_short, true),
    }

    return (
        <div>
            <div className={'mam3-type teaser-log-in-log-out-finance border'}>

                <div className="teaser-log-in-log-out-finance__image">
                    <img src={campaign.image_16_9} className="hero img-fluid" role="presentation" alt="Hero" />
                </div>

                <div className="text">
                    <ReactMarkdown {...MarkdownHelper.allTypes()}
                                   source={t(campaignWithSuperscript.title_caption, lang)} />
                    <br/>
                    <ReactMarkdown {...MarkdownHelper.headingTypes()}
                                   source={t(campaignWithSuperscript.title_2_short, lang)}
                                   escapeHtml={false} />
                </div>

            </div>
            <FootnotesFromContext showWarningText={footnotesWarningText} />
        </div>
    )

}

export default TeaserLogInLogOutFinance



// WEBPACK FOOTER //
// ./src/components/ads/creditcard/TeaserLogInLogOutFinance.js